import { ButtonColor } from '../../../../../ui/gzIconButton/types';
import { ConnectionOptions, DetectionRuleType, FileOptions, RegistryOptions } from '../../../../customRulesGrid/types';

export enum Type {
  ISOLATE = 1,
  COLLECT_INVESTIGATION_PACKAGE = 2,
  ADD_TO_SANDBOX = 3,
  KILL_PROCESS = 4,
  SCAN = 5,
  QUARANTINE = 6,
  RISK_SCAN = 7,
}

export interface KillProcessSettings {
  includeParent: boolean;
  includeChildren: boolean;
}

export enum ScanType {
  QUICK = 1,
  FULL = 2,
}

export interface ScanSettings {
  type: ScanType;
}

export interface QuarantineSettings {
  includeParentProcess: boolean;
  includeChildrenProcesses: boolean;
}

export interface AutomaticAction {
  type: Type;
  enabled: boolean;
  settings?: KillProcessSettings | ScanSettings | QuarantineSettings;
}

export enum GridColumn {
  TYPE = 'type',
  WARNING = 'warning',
  DETAILS = 'details',
  EDIT_SETTINGS = 'editSettings',
}

export enum Events {
  GO_TO_STEP2 = 'goToStep2',
}

const typesToWarningIconNamesAndColors = {
  [Type.ISOLATE]: ['ds-icon-notification_warning', ButtonColor.WARNING],
  [Type.KILL_PROCESS]: ['ds-icon-notification_warning', ButtonColor.WARNING],
  [Type.SCAN]: ['ds-icon-notification_info', ButtonColor.PRIMARY],
  [Type.QUARANTINE]: ['ds-icon-notification_warning', ButtonColor.WARNING],
};

/**
 * @throws {Error}
 */
export function getWarningIconNameAndColor(type: Type): [string, ButtonColor] {
  if (typesToWarningIconNamesAndColors[type]) {
    return typesToWarningIconNamesAndColors[type];
  }

  throw new Error(`No warning is displayed for automatic action with type "${type}".`);
}

export const typesWithSettings = [Type.KILL_PROCESS, Type.SCAN, Type.QUARANTINE];

const ruleTypesToCreationProcessFields = {
  [DetectionRuleType.FILE]: [
    FileOptions.CREATION_PROCESS_NAME,
    FileOptions.CREATION_PROCESS_PATH,
    FileOptions.CREATION_PROCESS_FULL_PATH,
    FileOptions.CREATION_PROCESS_COMMAND_LINE,
  ],
  [DetectionRuleType.CONNECTION]: [
    ConnectionOptions.CREATION_PROCESS_NAME,
    ConnectionOptions.CREATION_PROCESS_PATH,
    ConnectionOptions.CREATION_PROCESS_FULL_PATH,
    ConnectionOptions.CREATION_PROCESS_COMMAND_LINE,
  ],
  [DetectionRuleType.REGISTRY]: [
    RegistryOptions.CREATION_PROCESS_NAME,
    RegistryOptions.CREATION_PROCESS_PATH,
    RegistryOptions.CREATION_PROCESS_FULL_PATH,
    RegistryOptions.CREATION_PROCESS_COMMAND_LINE,
  ],
};

export function hasCreationProcessQueryRule(rule: any): boolean {
  if (!ruleTypesToCreationProcessFields[rule.query?.type]) {
    return false;
  }

  const creationProcessFields = ruleTypesToCreationProcessFields[rule.query?.type];

  return !!rule.query?.rules?.find((queryRule: any): any => creationProcessFields.includes(queryRule.criteriaValue));
}
